module.exports = __webpack_public_path__ + "media/src/StayPackage/images/skiLift-d00efca393065492499cfd26ae36db91.svg";